import React, { useEffect, useState, useRef } from 'react'

import { Box } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { FileDownloadData, MasterSearchFrom, SearchBox } from 'components/commonparts'
import { DataList } from 'components/parts/MasterTransportType'
import { useGridSearch } from 'hooks/useGridSearch';
import { useTransportType } from 'hooks/useTransportType'

import type { GetMstTransportTypeTransportTypeGetRequest, MstTransportType, ResponseResult } from 'api-client'

function MasterTransportType() {
  const { loginUserInfo } = useAuthContext()
  const trCompanyId = loginUserInfo?.companyId

  const initSearchParam: GetMstTransportTypeTransportTypeGetRequest = {
    companyId: trCompanyId ?? loginUserInfo!.companyId,
  }
  const [downloadColDef, setDownloadColDef] = useState<any[] | undefined>([]);
  const [hasGridEdited, setHasGridEdited] = useState<boolean>(false)
  const [downloadGridRows, setDownloadGridRows] = useState<MstTransportType[]>([])
  const [updateTrigger, setUpdateTrigger] = useState<boolean | undefined>(undefined)
  const [resultMessage, setResultMessage] = useState<ResponseResult | undefined>(undefined)
  const [gridMessage, setGridMessage] = useState<ResponseResult | undefined>(undefined)
  const [downloadMode, setDownloadMode] = useState<string>('csv')
  const isFirstRender = useRef(true);
  const { isLoading, transportTypeSearch, fetchTransportTypeSearch, transportTypeSearchResult } = useTransportType()
  const gridSearch = useGridSearch({ autoShowOnCtrlF: true })
  const [uploadData, setUploadData] = useState<any[]>([])

  useEffect(() => {
    setResultMessage(transportTypeSearchResult)
  }, [transportTypeSearchResult])
  useEffect(() => {
    setResultMessage(gridMessage)
  }, [gridMessage])

   useEffect(() => {
      const firstTimeRender = async () => { 
        if (isFirstRender.current) {
          isFirstRender.current=false
          const itemsPromise = fetchTransportTypeSearch({
            enabled: false,
            ...initSearchParam,
          });
          await Promise.all([itemsPromise]);
        }
      }
      firstTimeRender()
    }, [])
    
  const handleRegister = () => {
    setUpdateTrigger((prev) => !prev)
  }

  const onReload = () => {
    fetchTransportTypeSearch({
      enabled: false,
      ...initSearchParam,
    })
    setHasGridEdited(false)
  }

  const handleUploadData = async (headers: any[], data: any[]) => {
    const mappedData = data.map((row) => {
      const obj: any = {}
      headers.forEach((header, index) => {
        obj[header] = row[index]
      })
      return obj
    })
    setUploadData(mappedData)
  }
  
  const handleFileDownload = () => {
    setDownloadGridRows(generateDownloadData())
  }

  const generateDownloadData = (): MstTransportType[] => {
    if (!transportTypeSearch?.list || transportTypeSearch.list.length === 0) {
      return [{} as MstTransportType]
    }
    const downloadData: MstTransportType[] = [...transportTypeSearch.list]
    return downloadData
  }
  return (
    <Box>
      <MasterSearchFrom
        result={resultMessage}
        onDoUpdate={handleRegister}
        onReload={onReload}
        onImportData={handleUploadData}
        onFileDownLoad={handleFileDownload}
        setDownloadMode={setDownloadMode}
        hasDataEdited={hasGridEdited}
        importRequiredFields={['transport_type_name', 'max_weight', 'max_pallet_count']}
        headerJp={['輸送手段名', '最大積載重量（ｔ）', 'パレット最大積載枚数']}
        lastUpdateDatetime={transportTypeSearch?.lastUpdateDatetime}
      />
    <FileDownloadData fileName="輸送種類" downloadData={downloadGridRows} downloadMode={downloadMode} columnDefs={downloadColDef} />
    <SearchBox
      gridRef={gridSearch.searchBoxProps.gridRef}
      findSearchValue={gridSearch.searchBoxProps.findSearchValue}
      setFindSearchValue={gridSearch.searchBoxProps.setFindSearchValue}
      activeMatchNum={gridSearch.searchBoxProps.activeMatchNum}
      onFindChanged={gridSearch.searchBoxProps.onFindChanged}
      isVisible={gridSearch.searchBoxProps.isVisible}
      onHide={gridSearch.searchBoxProps.onHide}
    />
    <DataList
          list={transportTypeSearch}
          onReload={onReload}
          isLoading={isLoading}
          searchParam={initSearchParam}
          onUploadData={uploadData}
          updateTrigger={updateTrigger}
          setHasGridEdited={setHasGridEdited}
          setResultMessage={setGridMessage}
          setDownloadColumnDefs={setDownloadColDef}
          gridRef={gridSearch.gridRef}
          findSearchValue={gridSearch.gridSearchProps.findSearchValue}
          onFindChanged={gridSearch.gridSearchProps.onFindChanged}
          isSearchVisible={gridSearch.searchBoxProps.isVisible}
        />
    </Box>
  )
}

export default MasterTransportType
